import { useEffect, useState } from 'react'
import { exchangeFigmaCode } from '../api'

const FIGMA_STATE_KEY = 'fd_qa_tools_figma_oauth_state'

export default function FigmaCallback() {
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    handleCallback()
  }, [])

  const handleCallback = async () => {
    try {
      const params = new URLSearchParams(window.location.search)
      const code = params.get('code')
      const errorParam = params.get('error')
      const returnedState = params.get('state')

      if (errorParam) {
        setError(`Figma authorization error: ${errorParam}`)
        return
      }

      if (!code) {
        setError('No authorization code found')
        return
      }

      // Validate CSRF state — must match what was stored before the redirect
      const storedState = sessionStorage.getItem(FIGMA_STATE_KEY)
      sessionStorage.removeItem(FIGMA_STATE_KEY)
      if (!storedState || storedState !== returnedState) {
        setError('Connection failed: invalid state parameter')
        return
      }

      // Exchange code for tokens via our backend (user is already authenticated)
      await exchangeFigmaCode(code)

      // Redirect to settings with success indicator
      window.location.href = '/settings?figma=connected'
    } catch (err) {
      console.error('Figma callback error:', err)
      const message = err instanceof Error ? err.message : 'Failed to connect Figma account'
      window.location.href = '/settings?figma=error&message=' + encodeURIComponent(message)
    }
  }

  if (error) {
    return (
      <div className="min-h-screen bg-linear-bg flex items-center justify-center p-4">
        <div className="bg-linear-bg-card border border-linear-border-input rounded-xl shadow-xl p-8 max-w-md w-full">
          <div className="text-center mb-6">
            <svg
              className="w-16 h-16 text-error mx-auto mb-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            <h2 className="text-2xl font-bold text-linear-text mb-2">Figma Connection Error</h2>
            <p className="text-linear-text-secondary mb-6">{error}</p>
          </div>
          <button
            onClick={() => (window.location.href = '/settings')}
            className="btn btn-primary w-full"
          >
            Go to Settings
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-linear-bg flex items-center justify-center">
      <div className="text-center">
        <div className="spinner spinner-lg mx-auto mb-4"></div>
        <div className="text-linear-text-secondary">Connecting to Figma...</div>
      </div>
    </div>
  )
}
